import Birthday from "../../../entities/Birthday/ui/Birthday";

const BirthdayPage = () => {
    return ( 
        <main>
        <Birthday/>
        </main>
     );
}
 
export default BirthdayPage;